/**
 * @generated SignedSource<<5d2d283b3e324a38f4a4370eed92eb33>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type newslettersPageQuery$variables = Record<PropertyKey, never>;
export type newslettersPageQuery$data = {
  readonly newsletterCategories: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly entityId: string;
        readonly name: string;
        readonly newsletters: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly entityId: string;
              readonly name: string;
              readonly sourceUrl: string | null | undefined;
            };
          }>;
        } | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"newsletterCategoryItemListNewsletterCategory">;
      };
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"hooksNewsletterScrollEffectNewsletterCategoryConnection" | "hooksPreselectNewsletterNewsletterCategoryConnection">;
  };
};
export type newslettersPageQuery = {
  response: newslettersPageQuery$data;
  variables: newslettersPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": {
      "direction": "DESC",
      "field": "WEIGHT"
    }
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sourceUrl",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "text",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "newslettersPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "NewsletterCategoryConnection",
        "kind": "LinkedField",
        "name": "newsletterCategories",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "hooksNewsletterScrollEffectNewsletterCategoryConnection"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "hooksPreselectNewsletterNewsletterCategoryConnection"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NewsletterCategoryEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NewsletterCategory",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "newsletterCategoryItemListNewsletterCategory"
                  },
                  {
                    "alias": null,
                    "args": (v0/*: any*/),
                    "concreteType": "NewsletterConnection",
                    "kind": "LinkedField",
                    "name": "newsletters",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NewsletterEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Newsletter",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              (v2/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "newsletters(first:100,orderBy:{\"direction\":\"DESC\",\"field\":\"WEIGHT\"})"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "newsletterCategories(first:100,orderBy:{\"direction\":\"DESC\",\"field\":\"WEIGHT\"})"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "newslettersPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "NewsletterCategoryConnection",
        "kind": "LinkedField",
        "name": "newsletterCategories",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NewsletterCategoryEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NewsletterCategory",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": (v0/*: any*/),
                    "concreteType": "NewsletterConnection",
                    "kind": "LinkedField",
                    "name": "newsletters",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NewsletterEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Newsletter",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              (v4/*: any*/),
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FormattedValue",
                                "kind": "LinkedField",
                                "name": "description",
                                "plural": false,
                                "selections": (v5/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FormattedValue",
                                "kind": "LinkedField",
                                "name": "summary",
                                "plural": false,
                                "selections": (v5/*: any*/),
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "newsletters(first:100,orderBy:{\"direction\":\"DESC\",\"field\":\"WEIGHT\"})"
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "newsletterCategories(first:100,orderBy:{\"direction\":\"DESC\",\"field\":\"WEIGHT\"})"
      }
    ]
  },
  "params": {
    "cacheID": "4a5b21cd97f7e7eb796b87ff167e7c2a",
    "id": null,
    "metadata": {},
    "name": "newslettersPageQuery",
    "operationKind": "query",
    "text": "query newslettersPageQuery {\n  newsletterCategories(first: 100, orderBy: {field: WEIGHT, direction: DESC}) {\n    ...hooksNewsletterScrollEffectNewsletterCategoryConnection\n    ...hooksPreselectNewsletterNewsletterCategoryConnection\n    edges {\n      node {\n        entityId\n        name\n        ...newsletterCategoryItemListNewsletterCategory\n        newsletters(first: 100, orderBy: {field: WEIGHT, direction: DESC}) {\n          edges {\n            node {\n              entityId\n              name\n              sourceUrl\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment hooksNewsletterScrollEffectNewsletterCategoryConnection on NewsletterCategoryConnection {\n  edges {\n    node {\n      entityId\n      id\n    }\n  }\n}\n\nfragment hooksPreselectNewsletterNewsletterCategoryConnection on NewsletterCategoryConnection {\n  edges {\n    node {\n      entityId\n      newsletters(first: 100, orderBy: {field: WEIGHT, direction: DESC}) {\n        edges {\n          node {\n            entityId\n            id\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment newsletterCategoryItemListNewsletterCategory on NewsletterCategory {\n  entityId\n  name\n  newsletters(first: 100, orderBy: {field: WEIGHT, direction: DESC}) {\n    edges {\n      node {\n        entityId\n        ...newsletterItemCardNewsletter\n        id\n      }\n    }\n  }\n}\n\nfragment newsletterItemCardNewsletter on Newsletter {\n  entityId\n  name\n  description {\n    text\n  }\n  summary {\n    text\n  }\n}\n"
  }
};
})();

(node as any).hash = "45d09dc28fbf490c59a470863fa3cb9b";

export default node;
